import React, { memo } from 'react';
import { useTranslation } from 'react-i18next';
import { useWeakPasswords } from '../../hooks/useWeakPasswords';
import Information from '../Information/Information';

export default memo(function WeakPasswords(props) {
    const [t] = useTranslation('dashboard');

    useWeakPasswords(props.getWeakPasswordsRequest);

    return <Information
        description="Title description"
        error={props.weakPasswords.error}
        errorDescription={t('update_error')}
        fetching={props.weakPasswords.fetching}
        numericValue
        title={t('weak_passwords')}
        value={props.weakPasswords.qtty}
        showError
    />;
}, (prevProps, nextProps) =>
        prevProps.weakPasswords === nextProps.weakPasswords &&
        prevProps.getWeakPasswordsRequest === nextProps.getWeakPasswordsRequest
);
